import React from 'react';

/** Seta do badge de hover das ações rápidas (mesma do botão de canal do rodapé). */
export const ArrowRightIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 256 256"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z" />
  </svg>
);

export default ArrowRightIcon;
